<template>
  <search-form
    :focused-field="focusedField"
    :focused-class="focusedClass"
  />
</template>

<script>
import SearchForm from '@/components/SearchForm/SearchForm';
export default {
  components: {
    SearchForm,
  },
  props: {
    focusedField: {
      type: [ Boolean, String ],
      default: false,
    },
    focusedClass: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>

</style>
